import { useState, useEffect } from "react";
import { LuckydrawList } from "services/Api/Module/Luckydraw";

export const useLuckydraw = (limit, offset) => {
  const [luckydraws, setLuckydraws] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchLuckydraws = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const { data } = await LuckydrawList({ params: { limit, offset } });
      const ok = String(data?.resultCode ?? "") === "20000";
      const items = ok && Array.isArray(data.resultData) ? data.resultData : [];

      setLuckydraws(items);
      setRowCount(ok ? data.rowCount || 0 : 0);
    } catch (err) {
      console.error("Error fetching luckydraw list:", err);
      setLuckydraws([]);
      setRowCount(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLuckydraws();
  }, [limit, offset]);

  return {
    luckydraws,
    rowCount,
    isLoading,
    error,
    refetch: fetchLuckydraws,
  };
};
